import React from 'react';

import {
  Container,
  PhotoColumn,
  VideoPlayerContainer,
} from './photoGrid.styled';
import { PhotoGridData } from './photoGrid.types';
import { PhotoWithLabel } from './components/photoWithLabel/photoWithLabel.component';
import { VideoPlayer } from './components/videoPlayer/videoPlayer.component';

export const PhotoGrid: React.FC<PhotoGridData> = (data: PhotoGridData) => {
  const {
    firstLeftPhoto,
    secondLeftPhoto,
    firstRightPhoto,
    secondRightPhoto,
    video,
  } = data.items;

  return (
    <Container>
      <PhotoColumn>
        <PhotoWithLabel data={firstLeftPhoto} />
        <PhotoWithLabel data={secondLeftPhoto} />
      </PhotoColumn>
      <VideoPlayerContainer>
        <VideoPlayer
          cover={video.videoCover}
          label={video.label}
          videoId={video.videoId}
        />
      </VideoPlayerContainer>
      <PhotoColumn>
        <PhotoWithLabel data={firstRightPhoto} />
        <PhotoWithLabel data={secondRightPhoto} />
      </PhotoColumn>
    </Container>
  );
}
